<div class="row mt-3" *ngIf="!isViewPackageDetail && servicePackageList && servicePackageList.length>0">
  <div class="col-12">
    <b>{{servicePackageList.length}}&nbsp;</b>
    <span>service package result<span *ngIf="servicePackageList.length > 1">s</span></span>
  </div>
  <div class="col-sm mt-3 table-responsive no-gutter">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <th scope="col">Package Name</th>
          <th scope="col">Services</th>
          <th scope="col" class="text-center">Vehicles</th>
          <th scope="col">Rate-Plan Type</th>
          <th scope="col">Additional Discount</th>
        </tr>
      </thead>
      <tbody class="max-height-57">
        <tr class="cursor-pointer" *ngFor="let package of servicePackageList; let i = index"
          (click)="packageSelected(package)">
          <td>{{package.name}}</td>
          <td>
            <div *ngFor="let service of package.services">
              {{service.name | customText}}
            </div>
          </td>
          <td class="text-center">{{package.usageCount}}</td>
          <td class="pointer">
            <span>{{package.packageRatePlan.ratePlanType | customText}}</span><br>
            <span>{{package.packageRatePlan.usageType | customText}}</span>
          </td>
          <td class="pointer">
            <span
              *ngIf="(package.packageRatePlan.ratePlanType=='DEFAULT_SERVICE_RATES_OVERAGE_PRICING' || package.packageRatePlan.usageType == 'OVERAGE_CHARGING') && package.packageRatePlan.baseTierDiscount">
              Base Tier : {{package.packageRatePlan.baseTierDiscount}}%</span><br>
            <span
              *ngIf="(package.packageRatePlan.ratePlanType=='DEFAULT_SERVICE_RATES_OVERAGE_PRICING' || package.packageRatePlan.usageType == 'OVERAGE_CHARGING')&& package.packageRatePlan.overAgeTierDiscount">
              Overage Tier : {{package.packageRatePlan.overAgeTierDiscount}}%</span>
            <span
              *ngIf="package.packageRatePlan.additionalDiscount">{{package.packageRatePlan.additionalDiscount}}%</span>
            <span
              *ngIf="!package.packageRatePlan.baseTierDiscount && !package.packageRatePlan.overageTierDiscount && !package.packageRatePlan.additionalDiscount">
              None </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row mt-3" *ngIf="isViewPackageDetail">
  <div class="col-12">
    <app-view-account-service-package-new [servicePackageData]="selectedPackage" [isShowEditbtn]="false"
      (closeEmitter)="closePackageDetailClicked($event)">
    </app-view-account-service-package-new>
  </div>
</div>